import { isFeatureEnabled } from '@atlassiansox/frontend-feature-encoding';

import { isFedRamp } from '@atlassian/atl-context';

import { fg } from '@confluence/feature-gating';

import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';

export const useAIRovoButtonEnablement = () => {
	const { isAdminHubAIEnabled, isRovoLLMEnabled } = useSessionData();
	// Gate ON: environment-aware enablement via feature encoding; Gate OFF: legacy FedRAMP fallback
	const isAIFeatureEnabled = fg('use_frontend_feature_encoding_sdk')
		? isFeatureEnabled('confluence', 'confluence-ai')
		: !isFedRamp();
	return isAIFeatureEnabled && isAdminHubAIEnabled && isRovoLLMEnabled;
};
